import { $ } from "../utils";

// About image card component
const AboutImageCard = () => {
    // Getting motion
    const elements = document.querySelectorAll('.imageCard');

    // Each element
    for(var i = 0; i < elements.length; i++) {
        // Getting current element
        const current = elements[i];

        // Adding click event listener
        current.addEventListener('click', (e) => {
            // Prevent default event
            e.preventDefault();
            // Get sibling
            const sibling = current.previousElementSibling || current.nextElementSibling;
            // Sibling indexing
            sibling.style.zIndex = 3;
            // Current element
            current.style.zIndex = 4;
            // Toggle active
            current.classList.contains('active') ?
                current.classList.remove('active') :
                    current.classList.add('active');
        });
    }
};

// Export component
export default AboutImageCard;